import { DomainEvent } from '../../../../../core/domain/events/domain_event';
import { Appointment } from '../../appointment/appointment';

export class AppointmentEvent extends DomainEvent<Appointment> {}

export class AppointmentCreated extends AppointmentEvent {}
export class AppointmentUpdated extends AppointmentEvent {}
export class AppointmentDeleted extends AppointmentEvent {}
